export default "__VITE_ASSET__Djo96X41__"